import { TableBodyProps } from '../../types';
import parseArray from 'utils/parseArray';
import { KEYS_TO_BE_REMOVED } from '../..';
import { Cell } from '@tanstack/react-table';
import { Column, RowsActions } from '../index';
import '../../../Table/Observations.scss';

export const TableBody = ({
  table,
  columnVisibility,
  getObservationActions,
  flexRender,
  isExternalReviewer,
  observationNavigationContext,
}: TableBodyProps) => {
  return (
    <tbody>
      {table.getRowModel().rows.map((row: any, index: number) => {
        return (
          <tr
            key={index}
            className='cursor-pointer Close w-full item_data group border-y dark:border-lineLight dark:bg-secondaryLight dark:hover:bg-primaryExtraLight'
            style={{ height: '66px' }}
          >
            {parseArray(row.getVisibleCells(), KEYS_TO_BE_REMOVED).map(
              (cell: Cell<any, any>) => (
                <Column
                  hoverEffect='item_hover_effect'
                  flexRender={flexRender}
                  cell={cell}
                  columnVisibility={columnVisibility}
                  rowData={row}
                  observationId={row?.original?.id}
                  programManagers={row?.original?.programManagers}
                  isExternalReviewer={isExternalReviewer}
                  observationNavigationContext={observationNavigationContext}
                />
              )
            )}
            <td className='whitespace-nowrap sticky right-0 dark:bg-bgtetriaryz-10 bg-bgWhite item_hover_effect dark:bg-secondaryLight'>
              {!isExternalReviewer ? (
                <>
                  <RowsActions
                    row={row}
                    getObservationActions={getObservationActions}
                  />
                </>
              ) : (
                <></>
              )}
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};
